import router from '../../router'

const Utils = {
  GetQueryString (hash, name) {
    hash = hash || ''
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let r = hash.substr(1).match(reg)
    if (r != null) {
      return decodeURI(r[2])
    }
    return null
  },
  CountTime (val) {
    let timer = setInterval(() => {
      let h = Math.floor(val / 60 / 60)
      let m = Math.floor((val - h * 60 * 60) / 60)
      let s = Math.floor((val) - h * 60 * 60 - m * 60)
      if (val < 0) {
        clearInterval(timer)
      } else {
        return h + ':' + m + ':' + s
      }
      val--
    }, 1000)
  },
  setTitle (val) {
    document.title = val
  },
  buttonPermissions () {
    const wxUserStatus = sessionStorage.getItem('wxUserStatus')
    if (wxUserStatus === '1') {
      router.push('/bind')
      return false
    } else if (wxUserStatus === '2') {
      router.push('/login')
      return false
    }
    return true
  }
}
export default Utils



// WEBPACK FOOTER //
// ./src/common/js/utils.js